import { __module as shared } from '../../../_virtual/shared.js';
import { s as sharedStore } from './shared-store.js';

var store = sharedStore;

(shared.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.35.1',
  mode: 'pure' ,
  copyright: '© 2014-2024 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.35.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var sharedExports = shared.exports;

export { sharedExports as s };
//# sourceMappingURL=shared.js.map
